import React from 'react';
import { Route, Switch } from 'react-router-dom';
import asyncComponent from '../../../util/asyncComponent';

const BuffetDailyClosing = asyncComponent(() => import('./BuffetDailyClosing'));
const ReverseTicket = asyncComponent(() => import('./ReverseTicket'));

const ClosingAndOthers = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}/BuffetDailyClosing`} component={BuffetDailyClosing} />
    <Route exact path={`${match.url}/ReverseTicket`} component={ReverseTicket} />
  </Switch>
);

export default ClosingAndOthers;
